export const GET_ALL_COLOR_REQUEST = "GET_ALL_COLOR_REQUEST";
export const GET_ALL_COLOR_FAILURE = "GET_ALL_COLOR_FAILURE";
export const GET_ALL_COLOR_SUCCESS = "GET_ALL_COLOR_SUCCESS";